<script>
  function beforePrint() {
    const body = document.querySelector("body");
    body.style.backgroundImage = 'url("papeltimbrado.png")';
    body.style.backgroundSize = "contain";
    body.style.backgroundPosition = "center";
  }

  function afterPrint() {
    const body = document.querySelector("body");
    body.style.backgroundImage = "none";
  }

  window.addEventListener("beforeprint", beforePrint);
  window.addEventListener("afterprint", afterPrint);
</script>

<!-- Cabeçalho com logo e barra (será exibido em todas as páginas) -->
<div class="cabecalho">
  <div class="logo">
    <img src="img/logo2.png" alt="Logo" class="logo" />
  </div>

</div>

<h4>Tabela de Monitoramento de Saídas do Plano Alimentar</h4>
<div class="envolver">
  <img src="./img/marca.png" alt="Imagem" class="imagem-fixa" />

Exemplo

<table id="tabela-monitoramento">
  <thead>
    <tr>
      <th>Data</th>
      <th>Horário</th>
      <th>Refeição Planejada</th>
      <th>Motivo da Saída</th>
      <th>Refeição Realizada</th>
      <th>Observações</th>
    </tr>
  </thead>
  <tbody>
    <!-- Linha de exemplo (será removida na impressão) -->
    <tr>
      <td>Ex: 01/01/2024</td>
      <td>Ex: 08:00</td>
      <td>Ex: Café da Manhã</td>
      <td>Ex: Evento Social</td>
      <td>Ex: Pão com manteiga</td>
      <td>Ex: Quantidade extra consumida</td>
    </tr>
   
  </tbody>
</table>
</div>
<br>
<h5>Preencha abaixo conforme o exemplo acima</h5>
<div class="envolver">
  <table>
    <tbody>
      <tr>
        <th>Data</th>
        <th>Horário</th>
        <th>Refeição Planejada</th>
        <th>Motivo da Saída</th>
        <th>Refeição Realizada</th>
        <th>Observações</th>
      </tr>

      <!-- Linhas vazias para preenchimento (18 linhas) -->
      {#each Array(10) as _}
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
        </tr>
      {/each}
    </tbody>
  </table>
    <img src="img/barrainferior.png" alt="barra" class="barra" />
</div>

<style>
 @font-face {
    font-family: "Century Gothic";
    src: url("CenturyGothic.ttf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  .envolver { 
    margin-left:30px;
    margin-right: 30px;
       position: relative;
    border-radius: 20px; /* Arredonda as bordas */
    border: 2px solid #938e6d; /* Cor da borda igual à da barra */
    padding: 15px; /* Espaçamento interno para melhor aparência */
    background-color: transparent; /* Mantém o fundo branco */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Sombra sutil */
      font-family: "Century Gothic", sans-serif;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    background-color: transparent;
  }
h4,h5{
  font-family: "Century Gothic", sans-serif;
   margin-left:30px;
    margin-right: 30px;
}
  th,
  td {
    border: 1px solid black;
    padding: 10px;
    text-align: left;
    height: 40px; /* Altura das linhas para escrita */
  }

  th {
    background-color: #f0f0f0; /* Cor de fundo para o cabeçalho da tabela */
    font-weight: bold;
  }

  .cabecalho {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    flex-direction: column;
    background-color: transparent;
  }

  .logo {
       display: flex;
    justify-content: center;
    width:200px; 
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 10px;
  }

  .barra {
       display: none;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: auto;
    z-index: 5;
  }

    .imagem-fixa {
      display: block;
      position: absolute; /* Posiciona a imagem absolutamente dentro do calendario-secao */
      top: 50%;
      left: 50%;
      transform: translate(-50%, -10%); /* Centraliza o elemento */
      width: 50%; /* Ajuste conforme necessário */
      height: auto;
      opacity: 0.2;
      z-index: -1;
    }
</style>
